import {
  EntityList,
  EntityListProps,
  renderDate,
  renderEnum,
  renderYesNoIcon,
} from 'components/EntityList'
import { ParticipantChange, ParticipantChangeType } from 'model'
import { SelectionMode } from 'office-ui-fabric-react'
import * as React from 'react'
import { useTranslation } from 'react-i18next'
import { createFieldColumn } from 'views/helpers'

export type TaxRequirementsListProps = EntityListProps<ParticipantChange>

export const TaxRequirementsList: React.FC<TaxRequirementsListProps> = ({
  items,
  ...props
}) => {
  const { t } = useTranslation()
  const fieldColumn = React.useMemo(() => createFieldColumn(t), [t])
  const columns = React.useMemo(
    () => [
      fieldColumn('type', {
        onRender: renderEnum(t, 'participantChangeType'),
        name: 'Art der Änderung',
        getGroupValue: (item: ParticipantChange) =>
          t(`enum.participantChangeType.${item.type}`),
        minWidth: 100,
      }),
      fieldColumn('fullName', {}),
      fieldColumn('dateFrom', {
        onRender: renderDate,
      }),
      fieldColumn('dateTo', {
        onRender: renderDate,
      }),
      fieldColumn('isSentToInvolvedPeople', {
        name: 'E-Mail betroffene Personen',
        getGroupValue: (item: ParticipantChange) =>
          item.isSentToInvolvedPeople
            ? 'E-Mail an betroffene Personen gesendet'
            : 'E-Mail an betroffene Personen noch nicht gesendet',
        minWidth: 140,
        onRender: (item: ParticipantChange, i, col) =>
          item.type === ParticipantChangeType.Added
            ? renderYesNoIcon(item, i, col)
            : '-',
      }),
      fieldColumn('isSentToTaxOffice', {
        name: 'E-Mail Steuerkanzlei',
        getGroupValue: (item: ParticipantChange) =>
          item.isSentToInvolvedPeople
            ? 'E-Mail an Steuerkanzlei gesendet'
            : 'E-Mail an Steuerkanzlei noch nicht gesendet',
        onRender: renderYesNoIcon,
      }),
    ],
    [fieldColumn, t]
  )
  return (
    <EntityList
      items={items}
      columns={columns}
      alternate={true}
      stickyHeader={true}
      selectionMode={SelectionMode.none}
      readonly={true}
      {...props}
    />
  )
}
